import { UUITooltipTheme } from '../../../types/UUITooltip'

// Radix sets data-side and data-align on the Content element.
// align="center" (the default and only align used in-app) keeps Radix align="center":
// the bubble is centered on the trigger and the native Radix Arrow centers on the edge.
// The bubble stays fully rounded for center; the rounded-X-none rules below only fire
// for explicit align="start"/"end", squaring the corner nearest the aligned edge.
// The arrow is the native Radix Arrow (auto-positioned per side/align); it only needs a fill.

const tooltipTheme: UUITooltipTheme = {
  content: () =>
    [
      // Wrapper-level styles (z-index, shadow)
      'tw:z-1000',
      'tw:[filter:drop-shadow(0_8px_28px_rgba(115,125,140,0.45))]',
      // Content-level styles (bg, text, radius, padding)
      'tw:font-ubuntu tw:font-normal',
      'tw:text-[14px] tw:leading-[20px]',
      'tw:text-blue-400',
      'tw:bg-grey-1000',
      'tw:rounded-[20px]',
      'tw:p-[24px]',

      // Border-radius: set one corner to 0 based on data-side + data-align
      // Only start/end selectors needed (center maps to start internally)
      // side=top → arrow on bottom edge
      'tw:[&[data-side=top][data-align=start]]:rounded-bl-none',
      'tw:[&[data-side=top][data-align=end]]:rounded-br-none',
      // side=bottom → arrow on top edge
      'tw:[&[data-side=bottom][data-align=start]]:rounded-tl-none',
      'tw:[&[data-side=bottom][data-align=end]]:rounded-tr-none',
      // side=left → arrow on right edge
      'tw:[&[data-side=left][data-align=start]]:rounded-tr-none',
      'tw:[&[data-side=left][data-align=end]]:rounded-br-none',
      // side=right → arrow on left edge
      'tw:[&[data-side=right][data-align=start]]:rounded-tl-none',
      'tw:[&[data-side=right][data-align=end]]:rounded-bl-none'
    ].join(' '),

  // Native Radix Arrow (auto-centered on the trigger, auto-flipped per side).
  // Only needs the bubble fill so the tail matches the body; the drop-shadow on
  // the content wrapper wraps the arrow too.
  arrow: () => 'tw:fill-grey-1000'
}

export default tooltipTheme
